import { useEffect, useState } from 'react';
import {
  subscribeContactSubmissions,
  type ContactSubmissionsResult,
} from '@/lib/firestoreContact';

/**
 * Assina `/contactSubmissions` e expõe o estado tipado para a tela.
 *
 * Origem: sem issue — commit aae23995a, 2026-06-18 20:10 +0200 (tela de contato).
 *
 * Contrato: `LOADING` ao montar; `READY` com os 200 mais recentes
 * (`CONTACT_LIST_LIMIT`, `createdAt desc`) ou `ERROR` quando o listener cai.
 * Desassina ao desmontar. Só lê — a triagem escreve pela callable.
 *
 * Usado por: `features/contact/ContactMessagesPage.tsx` (rota `/contact/messages`).
 *
 * Dados: coleção raiz `contactSubmissions/{id}`, gravada pelo form da landing;
 * formato em `ContactSubmissionSchema` (`packages/types/src/contact.ts`), e o
 * parse/descartes moram em `subscribeContactSubmissions` (`lib/firestoreContact.ts`).
 * Leitura autorizada por `match /contactSubmissions/{id}` (`isSuperAdmin()`).
 */
export function useContactSubmissions(): ContactSubmissionsResult {
  const [state, setState] = useState<ContactSubmissionsResult>({ kind: 'LOADING' });
  useEffect(() => {
    setState({ kind: 'LOADING' });
    const unsub = subscribeContactSubmissions(setState);
    return unsub;
  }, []);
  return state;
}
